import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure75 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      marginLeft: 180,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'bar',
      height: '1000px',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
        fontFamily: 'Montserrat'
      }
    },

    colors: ['#ed7d31', '#5b9bd5'],

    credits: {
      enabled: false
    },
    title: {
      text: null
    },
    subtitle: {
      text: null
    },

    plotOptions: {
      series: {
        borderWidth: 0,
        marker: {
          symbol: 'circle',
          enabled: false,
          states: {
            hover: {
              enabled: true,
              radius: 5
            }
          }
        }
      }
    },

    exporting: {
      enabled: false
    },

    xAxis: [{
      categories: [
          "Monde",
          "",
          "Petits États insulaires en développement (PEID)",
          "Pays en développement sans littoral (PDSL)",
          "Pays les moins avancés (PMA)",
          "",
          "Océanie",
          "Asie de l’Est et Asie du Sud-Est",
          "Asie de l’Ouest et Afrique du Nord",
          "Asie centrale et du Sud",
          "Océanie hors Australie et Nouvelle-Zélande",
          "Australie et Nouvelle-Zélande",
          "Amérique du Nord et Europe",
          "Amérique latine et Caraïbes",
          "Asie du Sud-Est",
          "Asie du Sud",
          "Asie de l’Est",
          "Amérique du Nord",
          "Afrique subsaharienne",
          "Europe",
          "Afrique du Nord",
          "Asie de l’Ouest",
          "Asie centrale",
      ],
      lineColor: "#d7d7d7",
      tickColor: "#d7d7d7",
      tickLength: 16,
      labels: {
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        }
      },
    }],
    yAxis: [{
      labels: {
        	format: '{value}',
        style: {
          fontWeight: 'normal',
          color: '#999999',
          fontSize: '12px'
        },
      },
      max: 5,
      min: 0,
      tickInterval: 1,
      gridLineWidth: 0,
      title: {
        text: null,
        style: {
          color: Highcharts.getOptions().colors[1]
        }
      }
    }],
    tooltip: {
      shared: true,
      useHTML: true,
      hideDelay: 500,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      style: {
        padding: 0
      }
    },
    legend: {
      enabled: false,
    },

    series: [{
    name: 'État d’avancement actuel',
      tooltip: {
        valueSuffix: '%'
      },
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [
        3,
        null,
        4,
        3,
        3,
        null,
        4,
        3,
        3,
        3,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        4,
        3,
        3,
        4,

      ]
    },{
        name: 'Tendance',
      tooltip: {
        valueSuffix: '%'
      },
      dataLabels: {
        enabled: false,
        style: {
          fontWeight: 'normal',
          textOutline: false,
          color: '#999999',
          fontSize: '12px'
        }
      },
      data: [
        4,
        null,
        4,
        4,
        4,
        null,
        3,
        4,
        3,
        4,
        4,
        4,
        4,
        3,
        4,
        4,
        4,
        3,
        4,
        4,
        3,
        3,
        4,
      ],
    }]
}
